import React, { useEffect, useRef, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './WhyChooseUs.css';
import { MyContext } from '../../../../Context/MyContext';
import pic from '../../../../Assets/home.jpg';

// Count-up hook
const useCountUp = (target, duration = 1800, started = false) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!started) return;
    let start = null;
    const num = parseFloat(target);
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      setCount(Math.floor(progress * num));
      if (progress < 1) requestAnimationFrame(step);
      else setCount(num);
    };
    requestAnimationFrame(step);
  }, [started, target, duration]);
  return count;
};

const StatItem = ({ stat, started }) => {
  const val = useCountUp(stat.value, 1800, started);
  return (
    <div className="wcu-stat">
      <p className="wcu-stat-label">{stat.label}</p>
      <h3 className="wcu-stat-value">{val}{stat.suffix}</h3>
      <p className="wcu-stat-desc">{stat.desc}</p>
    </div>
  );
};

const WhyChooseUs = () => {
  const { whyChooseData } = useContext(MyContext);
  const navigate = useNavigate();
  const { eyebrow = '', headline_1 = '', headline_2 = '', cta_label = '', cta_url = '', stats = [] } = whyChooseData || {};

  // Parallax
  const sectionRef = useRef(null);
  const [offsetY, setOffsetY]     = useState(0);
  const [statsVisible, setStatsVisible] = useState(false);

  // Card reveal
  const cardRefs = useRef([]);
  const [visible, setVisible] = useState({});

  useEffect(() => {
    const onScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        setOffsetY(rect.top * 0.3);

        // trigger count-up when stats bar enters view
        if (rect.bottom > window.innerHeight * 0.3) setStatsVisible(true);
      }
      cardRefs.current.forEach((el, i) => {
        if (!el) return;
        if (el.getBoundingClientRect().top < window.innerHeight - 60)
          setVisible(prev => ({ ...prev, [i]: true }));
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* ── HERO IMAGE BLOCK (full width, like screenshot) ── */}
      <section className="wcu-hero" ref={sectionRef}>
        <div
          className="wcu-hero-bg"
          style={{ backgroundImage: `url(${pic})`, transform: `translateY(${offsetY}px)` }}
        />
        <div className="wcu-hero-dark" />

        <div className="wcu-hero-content">
          <p className="wcu-eyebrow">{eyebrow}</p>
          <h2 className="wcu-h1">{headline_1}</h2>
          <h2 className="wcu-h2">{headline_2}</h2>
        </div>

        {/* Floating CTA button top-right */}
        <button className="wcu-cta-btn" onClick={() => navigate(cta_url)}>
          {cta_label}
        </button>

        {/* Stats bar — overlaps bottom of hero */}
        <div className="wcu-stats-bar">
          {stats.map(stat => (
            <StatItem key={stat.id} stat={stat} started={statsVisible} />
          ))}
        </div>
      </section>
    </>
  );
};

export default WhyChooseUs;